<script>
    // [CI/CD] Praim AS Frontend Application
    import Router, { location } from "svelte-spa-router";
    import routes from "./routes/routes.js";
    import { onMount, onDestroy } from "svelte";
    import { Capacitor } from "@capacitor/core";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { FCM } from "@capacitor-community/fcm";
    import { Preferences } from "@capacitor/preferences";
    import * as store from "./stores/store";
    import { get } from "svelte/store";
    import * as Common from "./utiles/common.util";
    import { LocalNotifications } from "@capacitor/local-notifications";
    import { App } from "@capacitor/app";
    import { Toast } from "@capacitor/toast";

    let backPressedTime = 0;
    let backHandler;

    let currentPath = "";

    location.subscribe((path) => {
        if (path) {
            // 1. 현재 저장된 currentPath를 '이전 경로'로 보냄
            const previous = sessionStorage.getItem("currentPath");
            if (previous) {
                sessionStorage.setItem("fromPath", previous);
            }

            // 2. 새로운 경로를 '현재 경로'로 저장
            sessionStorage.setItem("currentPath", path);
            currentPath = path;
        }
    });

    onMount(() => {
        backHandler = App.addListener("backButton", async () => {
            let currentPath = window.location.hash.replace(/^#/, "");

            if (currentPath !== "/Home" && currentPath !== "/Login") {

                const goBackFn = get(store.currentGoBack);
                if (goBackFn) {
                    goBackFn();
                }
            } else {
                const now = Date.now();
                if (now - backPressedTime < 2000) {
                    App.exitApp();
                } else {
                    backPressedTime = now;
                    await Toast.show({
                        text: "앱을 종료하려면 한 번 더 눌러주세요",
                        duration: "short",
                    });
                }
            }
        });
    });

    onDestroy(() => {
        // 컴포넌트 해제 시 리스너 제거
        if (backHandler) backHandler.remove();
    });

    async function initPushNotifications() {
        try {
            // 1. Android 알림 채널 생성
            await LocalNotifications.createChannel({
                id: "default_channel",
                name: "기본 알림",
                description: "프라임AS 기본 알림 채널",
                importance: 5,
                visibility: 1,
                vibration: true,
            });

            await PushNotifications.createChannel({
                id: "default_channel",
                name: "기본 알림",
                description: "프라임AS 기본 알림 채널",
                importance: 5,
                visibility: 1,
                vibration: true,
            });

            // 2. 권한 요청
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive === "granted") {
                // 3. 리스너 먼저 등록 (register 호출 전에 등록 필수)
                PushNotifications.addListener("registration", async (t) => {
                    if (!t?.value) return;
                    let fcmToken = t.value;
                    console.log("FCM 토큰 발급 성공:", fcmToken);
                    store.fcm_token.set(fcmToken);
                    await Preferences.set({
                        key: "praimas_fcm_token",
                        value: fcmToken,
                    });
                });

                PushNotifications.addListener("registrationError", (err) => {
                    console.error("FCM 등록 실패:", err);
                });

                // 포그라운드 알림 수신 시 로컬 노티피케이션으로 상단 배너 표시
                PushNotifications.addListener(
                    "pushNotificationReceived",
                    async (notification) => {
                        console.log("푸시 수신 (포그라운드):", notification);
                        await LocalNotifications.schedule({
                            notifications: [
                                {
                                    title: notification.title || "알림",
                                    body: notification.body || "",
                                    id: Math.floor(Math.random() * 100000),
                                    schedule: { at: new Date(Date.now() + 100) },
                                    channelId: "default_channel",
                                    sound: "default",
                                },
                            ],
                        });
                    },
                );

                PushNotifications.addListener(
                    "pushNotificationActionPerformed",
                    (action) => {
                        console.log("푸시 알림 클릭:", action);
                    },
                );

                // 4. FCM 서버에 등록 요청
                await PushNotifications.register();

                // 5. FCM 토큰 즉시 직접 획득
                try {
                    const fcmRes = await FCM.getToken();
                    if (fcmRes && fcmRes.token) {
                        console.log("FCM.getToken 발급 완료:", fcmRes.token);
                        store.fcm_token.set(fcmRes.token);
                        await Preferences.set({
                            key: "praimas_fcm_token",
                            value: fcmRes.token,
                        });
                    }
                } catch (err) {
                    console.warn("FCM.getToken 호출 중 오류:", err);
                }
            } else {
                console.warn("푸시 알림 권한이 거부되었습니다.");
            }
        } catch (e) {
            console.error("푸시 알림 초기화 중 오류:", e);
        }
    }

    async function loadAccount() {
        const tokenRes = await Common.getStoredToken();
        const accountRes = await Common.getStoredAccount();

        if (tokenRes) store.jwt_token.set(tokenRes);
        if (accountRes) store.accountInfo.set(JSON.parse(accountRes));
    }

    onMount(async () => {
        loadAccount();

        if (Capacitor.isNativePlatform()) {
            await initPushNotifications();
        }
    });
</script>

<Router {routes} />
